import * as React from 'react';
import { connect } from 'react-redux';
import { requestAPIActions } from 'loopback-react-request';
import { GlobalPrivateState, plateBuilder } from 'src/api';

export interface ConfigurationDispatcherProps {
  configuration: GlobalPrivateState['configuration'];
  dispatch: Function;
  id: string;
  trough: GlobalPrivateState['trough'];
}

const dispatchKey = 'configuration';

class ConfigurationDispatcherContainer extends React.Component<ConfigurationDispatcherProps> {
  componentDidMount() {
    this.dispatchConfiguration();
  }

  /*
  componentDidUpdate(prevProps: ConfigurationDispatcherProps) {
    const configuration = this.props.configuration.result;
    const prevConf = prevProps.configuration.result;
    const trough = this.props.trough.result;
    const prevTrough = prevProps.trough.result;
    
    console.log('conf updated current', this.props.configuration, this.props.trough, );
    console.log('conf updated prev',prevProps.configuration, prevProps.trough, );
    if (configuration && trough && !this.props.plateBuilder.components) {
      this.props.dispatch(plateBuilder.assign({configuration, trough}));
    }
    
    if (
      (!prevTrough && configuration && trough) || 
      ((prevConf && prevConf.updated_at) !== (configuration && configuration.updated_at) && configuration && trough) || 
      (prevTrough && prevTrough.id) !== (trough && trough.id) && configuration && trough
    ) {
      this.props.dispatch(plateBuilder.assign({configuration, trough}));
    }

    if (
      configuration &&
      ((configuration && configuration.id) && (prevConf && prevConf.id)) && 
      (configuration && configuration.id !== this.props.id)
    ) {
      this.dispatchConfiguration();
      if (trough) {        
        this.props.dispatch(plateBuilder.assign({configuration, trough}));
      }
    }
  }
  */

  public render() {
    return null;
  }

  private dispatchConfiguration() {
    this.props.dispatch(requestAPIActions.load(
      dispatchKey, {
        url: `/Configurations/${this.props.id}`,
        queryParams: { include: 'order' }
      },
      true
    ));
  }
}


export const ConfigurationDispatcher = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  trough: state.trough,
}))(ConfigurationDispatcherContainer);
